// src/plugins/customConfirm.js
import Vue from 'vue';
import CustomConfirmModal from '../view/message/CustomConfirmModal.vue';

let confirmInstance;

const getConfirmInstance = (vueInstance) => {
    if (!confirmInstance) {
        const ConfirmComponent = Vue.extend(CustomConfirmModal);
        confirmInstance = new ConfirmComponent({
            // 关键：传递 i18n 实例
            i18n: vueInstance.$i18n,
            parent: vueInstance
        });

        const mountNode = document.createElement('div');
        document.body.appendChild(mountNode);
        confirmInstance.$mount(mountNode);
    }
    return confirmInstance;
};

const $customConfirm = function(options) {
    const instance = getConfirmInstance(this);
    return instance.confirm(options);
};

export default {
    install(Vue) {
        Vue.prototype.$customConfirm = $customConfirm;
    }
};

export { $customConfirm };